import { Button } from "@/components/ui/button";
const CTASection = () => {
  return <section id="events" className="py-20 bg-gradient-to-br from-primary to-primary/80 text-primary-foreground">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in">
          Become a Member Today!
        </h2>
        <p className="text-lg md:text-xl max-w-3xl mx-auto mb-8 opacity-95 animate-fade-in" style={{
        animationDelay: "0.2s"
      }}>
          Join our dynamic community of professionals and unlock exclusive networking opportunities. Experience the power of collaboration and referrals that can elevate your business to new heights. Don't miss out on the chance to grow with us!
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in" style={{
        animationDelay: "0.4s"
      }}>
          <Button size="lg" variant="secondary" asChild>
            <a href="/visit-a-meeting">
              Visit a Meeting
            </a>
          </Button>
          <Button size="lg" variant="outline" className="bg-transparent border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary" asChild>
            <a href="/benefits" aria-label="Learn more about RCN membership benefits">Learn More</a>
          </Button>
        </div>
      </div>
    </section>;
};
export default CTASection;